import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./hooks/apiRequest";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000,
      refetchOnWindowFocus: false,
      // Client errors (4xx — not found, forbidden, bad request) won't fix
      // themselves on retry. A 403 is a routine, expected outcome for a
      // final_user hitting a route the RBAC matrix disallows; retrying it
      // 3 times (the TanStack default) just delays the error UI, and a 401
      // retried blindly re-runs the refresh->logout chain repeatedly.
      // Server-side/network errors (5xx, or a non-ApiError like a fetch
      // failure) are still worth a couple of retries.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});
